import React, { useEffect, useState, useContext } from 'react';
import { LocaleContext, AuthContext, CartContext } from '../locale';
import './CheckoutSuccess.css';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:4000/api';

export default function CheckoutSuccess() {
  const { locale, t } = useContext(LocaleContext);
  const { user, token } = useContext(AuthContext);
  const { cart, removeFromCart } = useContext(CartContext);
  
  const [sessionId, setSessionId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [session, setSession] = useState(null);
  
  useEffect(() => {
    // Extract session ID from URL
    const urlParams = new URLSearchParams(window.location.hash.split('?')[1]);
    const sid = urlParams.get('session_id');
    setSessionId(sid);
    
    // Clear cart after successful payment
    if (cart && cart.length > 0) {
      cart.forEach(item => removeFromCart(item.id));
    }
  }, [cart, removeFromCart]);
  
  // Load session details
  useEffect(() => {
    if (!sessionId || !token) return;
    
    const fetchSession = async () => {
      try {
        const res = await fetch(`${API_BASE}/payments/checkout-session/${sessionId}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (!res.ok) {
          throw new Error('Failed to load payment details');
        }
        
        const data = await res.json();
        setSession(data.session);
      } catch (err) {
        console.error('Error fetching session:', err);
        setError(err.message || 'Failed to load payment information');
      } finally {
        setLoading(false);
      }
    };
    
    fetchSession();
  }, [sessionId, token]);
  
  return (
    <div className="checkout-success-page">
      <div className="container">
        <div className="success-card">
          <div className="success-icon">✅</div>
          <h1 className="success-title">Payment Successful!</h1>
          <p className="success-message">
            Thank you for your order. We're processing it now and will send you a confirmation email shortly.
          </p>
          
          {loading ? (
            <div className="success-loading">
              <div className="spinner"></div>
              <p>Loading order details...</p>
            </div>
          ) : error ? (
            <div className="success-error">
              <p>{error}</p>
            </div>
          ) : session ? (
            <div className="success-details">
              <div className="details-row">
                <span className="label">Order Amount:</span>
                <span className="value">
                  {new Intl.NumberFormat(locale === 'fr' ? 'fr-FR' : 'en-US', {
                    style: 'currency',
                    currency: 'EUR'
                  }).format(session.amount_total / 100)}
                </span>
              </div>
              <div className="details-row">
                <span className="label">Email:</span>
                <span className="value">{session.customer_details?.email || user?.email || 'Not available'}</span>
              </div>
              <div className="details-row">
                <span className="label">Order Reference:</span>
                <span className="value order-ref">{sessionId}</span>
              </div>
            </div>
          ) : null}
          
          <div className="success-actions">
            <a href="#/products" className="btn primary">Continue Shopping</a>
          </div>
        </div>
      </div>
    </div>
  );
}
